import { Clickable, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Arrows } from '../../components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 76px;
  position: relative;

  @media (min-width: 1024px) {
    .mobile-heading {
      display: none;
    }
  }

  @media (max-width: 1024px) {
    margin: 148px 0 35px;

    h4 {
      font-size: 30px;
      color: ${theme.SECONDARY};
      font-weight: 500;
      margin: 0 17px 28px;
    }
  }
`;

const BgsContainer = styled.div`
  position: absolute;
  width: 100vw;
  display: flex;
  flex-direction: column;
  z-index: 1;
  top: -20px;
`;

const RedBg = styled.div`
  height: 464px;
  width: 1280px;
  background-color: ${theme.SECONDARY};
  align-self: center;

  @media (max-width: 1024px) {
    margin-top: 4px;
    width: 100vw;
    height: 397px;
  }
`;

const GreenBg = styled.div`
  height: 183px;
  width: 100%;
  background-color: ${theme.GREEN};

  @media (max-width: 1024px) {
    width: 100vw;
    height: 102px;
  }
`;

const ContentContainer = styled.div`
  z-index: 2;
  display: flex;
  flex-direction: column;
`;

const HeaderImage = styled.img`
  margin: 25px 0 0;
  @media (max-width: 1024px) {
    display: none;
  }
`;

const ScrollContainer = styled.div`
  ${navigator.platform !== 'Win32' ? 'overflow-x: scroll;' : 'overflow-x: hidden;'}
  padding-left: ${(props) => props.extraPad};
  display: flex;
  margin-top: 23px;

  @media (max-width: 1024px) {
    margin-top: 25px;
    padding-left: 17px;
    overflow-x: scroll;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  width: 1140px;
  align-self: center;
  position: relative;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const AthleteFocusHeader = styled.div`
  margin-top: 19px;
  margin-left: 10px;

  h4 {
    font-size: 30px;
    font-weight: 500;
    color: ${theme.SECONDARY};
  }

  h3 {
    font-size: 72px;
    line-height: 54px;
    margin-top: 19px;
    letter-spacing: -3.5px;
  }

  @media (max-width: 1024px) {
    margin-top: 0;

    .desktop-h3 {
      display: none;
    }

    .mobile-h3 {
      margin-top: 20px;
      h3 {
        margin-top: 0;
        font-size: 48px;
        line-height: 37.44px;
        letter-spacing: -1.5px;
        color: white;
      }
    }

    h4 {
      display: none;
    }
  }

  @media (min-width: 1024px) {
    .mobile-h3  {
      display: none;
    }
  }
`;

const HeaderText = styled(Text)`
  @media (max-width: 1024px) {
    font-size: 16px;
  }
`;

const AthleteItem = styled.div`
  width: 330px;
  margin-right: 40px;

  img {
    width: 330px;
    height: 330px;
    margin-bottom: 12px;
  }

  h5  {
    font-weight: 400;
    color: #fff;
    font-size: 20px;
  }

  p  {
    font-size: 22px;
  }

  @media (max-width: 1024px) {
    width: 240px;
    margin-right: 30px;

    img {
      width: 240px;
      height: 240px;
      margin-bottom: 5px;
    }

    h5  {
      font-weight: 400;
      color: #fff;
      font-size: 16px;
    }

    p  {
      font-size: 16px;
    }
  }
`;

const ArrowsContainer = styled.div`
  position: absolute;
  right: -11px;
  top: 158px;
`;

const GoToAthletes = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 1180px;
  align-self: center;
  margin-top: 51px;
  margin-right: 17px;

  p {
    font-size: 20px;
    letter-spacing: -0.35px;

    b {
      letter-spacing: -0.6px;
    }
  }

  @media (max-width: 1024px) {
    width: 100vw;
    margin-top: 34px;
    margin-right: 19px;

    p {
      font-size: 16px;
    }
  }
`;

const AthleteFocus = (props) => {
  const { t } = useTranslation();
  const [extraPad, setExtraPad] = useState('0px'),
    scrollRef = useRef(null),
    navigate = useNavigate();

  useEffect(() => {
    handleExtraPad();
  }, []);

  function handleExtraPad() {
    setExtraPad(`${(window.innerWidth - 1140) / 2}px`);
  }

  return null;

  return (
    <Container>
      <ContentContainer>
        <HeaderRow>
          <AthleteFocusHeader>
            <HeaderText size="24px" col="white">
              {t('website.seeOurWork')}
            </HeaderText>
            <HeaderImage src={require('assets/images/we-all-play-better-together.png')} />

            <div className="mobile-h3">
              <Text h3 stencil>
                {t('website.weAll')}
              </Text>
              <Text h3 stencil>
                {t('website.playBetter')}
              </Text>
              <Text h3 stencil>
                {t('website.together')}
              </Text>
            </div>
          </AthleteFocusHeader>

          <ArrowsContainer>
            <div className="absolute-arrows">
              <Arrows col="white" elem={scrollRef} />
            </div>
          </ArrowsContainer>
        </HeaderRow>

        <ScrollContainer extraPad={extraPad} ref={scrollRef}>
          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.video')}</Text>
            <Text>{t('website.tiffanyVan')}</Text>
          </AthleteItem>

          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.video')}</Text>
            <Text>{t('website.tiffanyVan')}</Text>
          </AthleteItem>

          <AthleteItem>
            <img src={require('assets/images/pogba.png')} alt="" />

            <Text h5>{t('website.video')}</Text>
            <Text>{t('website.tiffanyVan')}</Text>
          </AthleteItem>

          <div>
            <AthleteItem>
              <img src={require('assets/images/pogba.png')} alt="" />

              <Text h5>{t('website.video')}</Text>
              <Text>{t('website.tiffanyVan')}</Text>
            </AthleteItem>
          </div>
        </ScrollContainer>
      </ContentContainer>

      <BgsContainer>
        <RedBg />
        <GreenBg />
      </BgsContainer>

      <GoToAthletes>
        <Clickable onClick={() => navigate('/our-athletes')}>
          <Text>
            Go to <b>Our Athletes</b>
          </Text>
        </Clickable>
      </GoToAthletes>
    </Container>
  );
};

export default AthleteFocus;
